import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

import Swal from "sweetalert2";

import { apiUrl, serverUrl } from "./Helpers/Config";

import ButtonHashtag from "./Button/ButtonHashtag";

import "../styles/feed.styles.scss";
import moment from "moment";
import AvatarGroup from "./LikeComment/AvatarGroup";
import CommentInput from "./LikeComment/CommentInput";
import { useHistory, useLocation } from "react-router-dom";
import LikeComment from "./LikeComment/LikeComment";
import { useDispatch } from "react-redux";
import Comment from "./LikeComment/Comment";
import { MdOutlineClose } from "react-icons/md";
import { useSelector } from "react-redux";
import { deletePost, getChange } from "../redux/actions/userReflection";
import {
  getProfilePic,
  htmlToText,
  trimString,
  convertDate,
  convertDateFormat,
  tokenAuthorize,
  removeIframe,
  Loading,
} from "./Helpers/Common";
import { staticFiles } from "./Helpers/Static";
import {
  ActiveIconColor,
  BgComment,
  BgWhite,
  ButtonCommonTopNew,
  Card,
  ButtonCommonDelete,
} from "../pages/Theme";
import { theme } from "../pages/PageWrapper";
import JournalHashtag from "./Button/JournalHashtag";
import ButtonCommon from "./Button/ButtonCommon";
import ReflectionCardRichText from "./Editor/ReflectionCardRichText";
import Tooltip from "@mui/material/Tooltip";
import SortToggle from "./Button/SortToggle";
import { GrRevert } from "react-icons/gr";
import { TbShareOff } from "react-icons/tb";

const NO_IMAGE = staticFiles.noImage;

const ReflectionCards = ({
  item,
  shareToUser,
  handleLike,
  onPostDelete,
  isView,
  gridView,
  saveFilter = null,
}) => {
  const history = useHistory();
  const location = useLocation();

  const userProfile = useSelector((state) => state.auth.user);

  const [comment, setComment] = useState("");
  const [commentsCount, setCommentsCount] = useState("0");
  const [latestComment, setLatestComment] = useState("0");
  const postId = item.reflection_id;

  //shared
  const isChange = useSelector((state) => state.reflections.change);

  const dispatch = useDispatch();
  const userId = localStorage.getItem("user_id");
  const [commentList, setCommentList] = useState([]);
  const [commentLatest, setCommentLatest] = useState([]);
  const [likesList, setLikesList] = useState([]);

  const [sortOrder, setsortOrder] = useState("desc");
  const [numComments, setnumComments] = useState(0);
  // let likesListDummy = [{photo: profilePhoto}, {photo: profilePhoto}, {photo: profilePhoto},
  //                         {photo: profilePhoto}, {photo: profilePhoto}, {photo: profilePhoto},
  //                     ]

  const [toggleComment, setToggleComment] = useState(false);

  const [currentIsLiked, setCurrentIsLiked] = useState();
  const numLikes = parseInt(likesList.length);
  // const numComments = commentList.length

  const [sortOrderInitial, setsortOrderInitial] = useState("desc");
  const [loadingComments, setLoadingComments] = useState(false);
  const [offsetComments, setOffsetComments] = useState(0);
  const [hasMoreComments, setHasMoreComments] = useState(false);
  const [readMore, setReadMore] = useState(false);
  const handleCommentClick = () => {
    if (gridView == false) {
      setToggleComment(!toggleComment);
      // if (!toggleComment === true) {
      //     getComments(postId)
      // }
      let str = sortOrder;
      if (localStorage.getItem("sortOrder") != undefined) {
        str = localStorage.getItem("sortOrder");
        setsortOrder(str);
      }
      if (!toggleComment === false) {
        changeLike();
        setOffsetComments(0);
        setHasMoreComments(false);
        setsortOrderInitial(str);
        setCommentList([]);
      }
      if (!toggleComment === true) {
        setLoadingComments(true);
        getComments(str, offsetComments);
      }
      // if (!toggleComment === false) {
      //     setsortOrder("desc")
      // }
      // getComments(str)
    } else {
      history.push(`/post/${postId}`, { src: location.pathname });
      if (saveFilter) {
        saveFilter();
      }
    }
  };

  const loadMoreComments = () => {
    setLoadingComments(true);
    let count = offsetComments + 10;
    setOffsetComments(offsetComments + 10);
    getComments(sortOrder, count, true);
  };

  useEffect(() => {
    let str = sortOrder;
    if (localStorage.getItem("sortOrder") != undefined) {
      str = localStorage.getItem("sortOrder");
    }
    setsortOrder(str);
    setsortOrderInitial(str);
    // getComments(str)
  }, [postId]);

  useEffect(() => {
    getLikes();
    // getComments();
    changeLike();
  }, [postId]);

  const changeLike = () => {
    return axios.get(apiUrl + "reflection/" + postId).then((res) => {
      if (res.status === 200) {
        let like = res.data.post.like;
        setCurrentIsLiked(parseInt(like));
        setCommentsCount(res.data.post.comments_count);
        setLatestComment(res.data.post.latest_comment);
      }
    });
  };

  const getLikes = () => {
    return axios
      .get(apiUrl + "likes/" + postId)
      .then((resp) => {
        if (resp.status === 200) {
          let likesList = resp.data.results;

          setLikesList(likesList);
          // dispatch(getShowcases());
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  };

  const likePost = (postId, isLiked) => {
    return axios
      .post(serverUrl.ReflectionPost + "/like", {
        reflection_id: postId,
        like: isLiked,
      })
      .then((resp) => {
        if (resp.status === 200) {
          getLikes(postId);
          changeLike();
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  };

  const getComments = (str, offset) => {
    return axios
      .get(
        apiUrl +
          "comments/" +
          postId +
          "?sort_order=" +
          sortOrderInitial +
          "&limit=10&offset=" +
          offset
      )
      .then((resp) => {
        if (resp.status === 200) {
          let data = [];
          data = resp.data.results;
          if (resp.data.results?.length > 9) {
            setHasMoreComments(true);
          } else {
            setHasMoreComments(false);
          }
          data = [...data, ...commentList];
          if (sortOrder == "asc") {
            const ascSortedData = data
              ?.slice()
              .sort((a, b) => new Date(a.created_on) - new Date(b.created_on));
            setCommentList(ascSortedData);
          }
          if (sortOrder == "desc") {
            const descSortedData = data
              ?.slice()
              .sort((a, b) => new Date(b.created_on) - new Date(a.created_on));
            setCommentList(descSortedData);
          }
          setLoadingComments(false);
          // let newCommentList = resp.data.results
          // setCommentList(newCommentList)
          // setnumComments(newCommentList.length);
          // if (newCommentList?.length > 0) {
          //     if (str == "desc") {
          //         setCommentLatest([newCommentList[0]])
          //     }
          //     if (str == "asc") {
          //         setCommentLatest([newCommentList[newCommentList?.length - 1]])
          //     }
          // }
        } else {
          setLoadingComments(false);
        }
      })
      .catch((err) => {
        setLoadingComments(false);
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  };

  const deleteComment = (commentId) => {
    Swal.fire({
      heightAuto: false,
      title: "Confirmation",
      text: "Are you sure you want to delete this comment?",
      icon: "warning",
      showCancelButton: false,
      showDenyButton: true,
      confirmButtonText: "Confirm",
      denyButtonText: "Cancel",
      confirmButtonColor: "#3085d6",
      denyButtonColor: "#c1c1c1",
    }).then((result) => {
      if (result.isConfirmed) {
        return axios
          .delete(serverUrl.Comment2 + "/" + commentId)
          .then((resp) => {
            if (resp.status === 200) {
              let count = commentsCount - 1;
              setCommentsCount(count);
              let str = sortOrder;
              if (localStorage.getItem("sortOrder") != undefined) {
                str = localStorage.getItem("sortOrder");
                setsortOrder(str);
              }
              const data = commentList.filter(
                (item) => item.reflection_comment_id !== commentId
              );
              setCommentList(data);
              // getComments(postId)
            }
          })
          .catch((err) => {
            tokenAuthorize(err?.response?.status);
            console.log(err);
          });
      }
    });
  };

  const addComment = (commentText, isPublic) => {
    return axios
      .post(serverUrl.ReflectionPost + "/comment", {
        reflection_id: postId,
        comment: commentText,
        visibility: isPublic,
      })
      .then((resp) => {
        if (resp.status === 200) {
          let str = sortOrder;
          if (localStorage.getItem("sortOrder") != undefined) {
            str = localStorage.getItem("sortOrder");
            setsortOrder(str);
          }
          let count = commentsCount + 1;
          setCommentsCount(count);
          let object = [
            {
              photo: userProfile?.photo,
              fullname: userProfile?.fullname,
              created_on: new Date(),
              guid: userProfile?.guid,
              reflection_comment_id: resp.data?.reflection_comment_id,
              user_id: resp.data?.user_id,
              comments: commentText,
              visibility: isPublic,
            },
          ];
          if (toggleComment == false) {
            setCommentList([]);
            setOffsetComments(0);
            setToggleComment(true);
            setLoadingComments(true);
            getComments(str, offsetComments);
          } else {
            if (str == "desc") {
              if (hasMoreComments == false || sortOrderInitial == "desc") {
                setCommentList([...object, ...commentList]);
              }
            }
            if (str == "asc") {
              if (hasMoreComments == false || sortOrderInitial == "desc") {
                setCommentList([...commentList, ...object]);
              }
            }
          }
          setComment("");
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  };

  const handleDeletePost = () => {
    //---------------------------------------------------

    if (shareToUser === true) {
      Swal.fire({
        heightAuto: false,
        title: "Confirmation",
        text: "Are you sure to unshare this post?",
        icon: "warning",
        showCancelButton: false,
        showDenyButton: true,
        confirmButtonText: "Confirm",
        denyButtonText: "Cancel",
        confirmButtonColor: "#3085d6",
        denyButtonColor: "#c1c1c1",
      }).then((result) => {
        if (result.isConfirmed) {
          return axios
            .delete(serverUrl.UnshareUser + "/" + item.shared_user_id)
            .then((res) => {
              if (res.status === 200) {
                dispatch(getChange(!isChange));
              }
            })
            .catch((err) => {
              console.log(err);
              tokenAuthorize(err?.response?.status);
            });
        }
      });
    } else if (shareToUser === false) {
      Swal.fire({
        heightAuto: false,
        title: "Confirmation",
        text: "Are you sure to unshare this post?",
        icon: "warning",
        showCancelButton: false,
        showDenyButton: true,
        confirmButtonText: "Confirm",
        denyButtonText: "Cancel",
        confirmButtonColor: "#3085d6",
        denyButtonColor: "#c1c1c1",
      }).then((result) => {
        if (result.isConfirmed) {
          return axios
            .delete(serverUrl.UnshareGroup + "/" + item.shared_group_id)
            .then((res) => {
              if (res.status === 200) {
                dispatch(getChange(!isChange));
              }
            })
            .catch((err) => {
              console.log(err);
              tokenAuthorize(err?.response?.status);
            });
        }
      });
    }

    //-------------------------------------------------
    else {
      Swal.fire({
        heightAuto: false,
        title: "Confirmation",
        text: "Are you sure to unshare this post?",
        icon: "warning",
        showCancelButton: false,
        showDenyButton: true,
        confirmButtonText: "Confirm",
        denyButtonText: "Cancel",
        confirmButtonColor: "#3085d6",
        denyButtonColor: "#c1c1c1",
      }).then((result) => {
        if (result.isConfirmed) {
          return axios
            .delete(
              serverUrl.Community + "/" + item.group_id + "/posts/" + postId
            )
            .then((res) => {
              if (res.status === 200) {
                dispatch(deletePost(item.group_id, postId));
                dispatch(getChange(!isChange));
              }
            })
            .catch((err) => {
              console.log(err);
              tokenAuthorize(err?.response?.status);
            });
        }
      });
    }
  };

  const handleSort = (str) => {
    setsortOrder(str);
    localStorage.setItem("sortOrder", str);
    if (str == "asc") {
      const ascSortedData = commentList
        ?.slice()
        .sort((a, b) => new Date(a.created_on) - new Date(b.created_on));
      setCommentList(ascSortedData);
    }
    if (str == "desc") {
      const descSortedData = commentList
        ?.slice()
        .sort((a, b) => new Date(b.created_on) - new Date(a.created_on));
      setCommentList(descSortedData);
    }
    // getComments(str)
  };

  return (
    <>
      <div
        className={`${"cardBackgroundColor shadow-sm border20px overflow-hidden relative cursor-pointer w-full"}`}
        onClick={() => {
          history.push(`/post/${postId}`, { src: location.pathname });
          if (saveFilter) {
            saveFilter();
          }
          sessionStorage.setItem("lastPostId", postId);
        }}
      >
        <div
          className={`flex flex-col justify-between p-6 ${
            !gridView && toggleComment ? "" : "h-full"
          }`}
        >
          <div className="">
            <div className="flex flex-col md:flex-row gap-2 justify-between items-center mb-7">
              <p
                className="blackColor text-lg font-bold"
                title={item.reflection_title}
              >
                {trimString(item.reflection_title, 50)}
              </p>
              <div
                className="flex gap-2 items-center"
                onClick={(e) => e.stopPropagation()}
              >
                <p className="lightColor text-sm">
                  {moment
                    .utc(item.reflection_updated_on)
                    .local()
                    .startOf("seconds") 
                    .fromNow()}{" "}
                  ({convertDateFormat(item.reflection_updated_on)})
                </p>
                {item.updateable && (
                  <Tooltip title={"Unshare post"} placement="top" arrow>
                    <ButtonCommonTopNew
                      className="p-2 cursor-pointer rounded-lg"
                      onClick={handleDeletePost}
                    >
                      <TbShareOff className="primaryIcon w-4 h-4 cursor-pointer" />
                    </ButtonCommonTopNew>
                  </Tooltip>
                )}
                {(shareToUser === true || shareToUser === false) && (
                  <Tooltip title={"Unshare post"} placement="top" arrow>
                    <ButtonCommonTopNew
                      className="p-2 cursor-pointer rounded-lg"
                      onClick={handleDeletePost}
                    >
                      <TbShareOff className="primaryIcon w-4 h-4 cursor-pointer" />
                    </ButtonCommonTopNew>
                  </Tooltip>
                )}
              </div>
            </div>
            {item.hashtag && !gridView && (
              <div className="pb-2">
                <div className={`flex flex-row flex-wrap gap-2`}>
                  {item.hashtag.map((hashtag, idx) => (
                    <JournalHashtag key={idx} text={hashtag} color="blue" />
                  ))}
                </div>
              </div>
            )}
            <div
              className="reflection-card-image-grid mb-7"
              style={{
                backgroundImage: `url(${
                  item.reflection_image
                    ? item.reflection_image?.replaceAll(" ", "%20")
                    : NO_IMAGE
                })`,
              }}
            >
              {/* <img
                            className='w-full object-contain h-full'
                            src={item.reflection_image ? item.reflection_image?.replaceAll(" ", "%20") : NO_IMAGE}
                            onError={(e) => { e.target.src = NO_IMAGE }}

                        /> */}
            </div>
            <div className="pb-2 overflow-hidden">
              <div className="text-viewer flex-1 text-sm lg:text-base break-words font-normal mb-3 container-multi overflow-wrap-break-word">
                <ReflectionCardRichText
                  htmlContent={removeIframe(item.reflection_content)}
                  maxLines={6}
                  setReadMore={setReadMore}
                />
              </div>
            </div>
          </div>
          <div className="">
            <div className="flex flex-col md:flex-row gap-1.5 items-center justify-between py-2">
              {/* <Link to={"/profile/" + item.guid} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
                            <img src={getProfilePic(item.photo)} alt="pics" className='rounded-full w-10 h-10 object-cover' />
                        </Link> */}

              <div className=" flex gap-2 w-full">
                {item.fullname && (
                  <div className="flex gap-1">
                    <p className="text-sm lightColor pt-0.5">By</p>
                    <Link
                      className="nav-navigate font-semibold"
                      title={item.fullname}
                      to={"/profile/" + item.guid}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <ActiveIconColor className="hover:underline">
                        {trimString(item.fullname, 55)}
                      </ActiveIconColor>
                    </Link>
                  </div>
                )}
                {shareToUser !== true && item.group_name ? (
                  <div
                    className="flex flex-col md:flex-row"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="flex gap-1">
                      <p className="text-sm lightColor pt-0.5">In</p>
                      {location.pathname ===
                      `/community/groups/${item.group_id}` ? (
                        <p
                          title={item.group_name}
                          className="blackColor font-semibold text-base"
                        >
                          {trimString(item.group_name, 55)}
                        </p>
                      ) : (
                        <a
                          className="cursor-pointer nav-navigate font-semibold"
                          onClick={() =>
                            history.push(`/community/groups/${item.group_id}`, {
                              src: location.pathname,
                            })
                          }
                          title={item.group_name}
                        >
                          <ActiveIconColor className="hover:underline">
                            {trimString(item.group_name, 55)}
                          </ActiveIconColor>
                        </a>
                      )}
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
              {readMore && (
                <div className=" whitespace-nowrap flex blueColor cursor-pointer hover:underline">
                  Read More...
                </div>
              )}
            </div>
            {!gridView && (
              <div className="pt-1" onClick={(e) => e.stopPropagation()}>
                <CommentInput
                  comment={comment}
                  setComment={setComment}
                  commentPost={addComment}
                  profilePhoto={staticFiles.noProfilePic}
                />
              </div>
            )}
            <div
              className="flex flex-1 md:flex-row pt-1"
              onClick={(e) => e.stopPropagation()}
            >
              {likesList.length > 0 && <AvatarGroup likesList={likesList} />}
              <LikeComment
                currentIsLiked={currentIsLiked}
                numLikes={numLikes}
                numComments={commentsCount}
                handleComment={handleCommentClick}
                likesList={likesList}
                handleLike={(e) => {
                  e.stopPropagation();
                  likePost(postId, currentIsLiked === 1 ? 0 : 1);
                }}
              />
            </div>
          </div>
        </div>
        <div
          className={`backgroundColor8 border20pxbottom border px-5 shadow-sm w-full ${
            !gridView && toggleComment ? "block" : "hidden"
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="items-center relative my-3">
            {commentList?.length > 0 && (
              <>
                <div className="flex flex-col sm:flex-row items-center justify-between">
                  <p className="text-base font-semibold blackColor">
                    Comments ({commentsCount})
                  </p>
                  {toggleComment == true && (
                    <SortToggle onChange={handleSort} sortOrder={sortOrder} />
                  )}
                </div>
              </>
            )}
            {toggleComment === false && (
              <>
                {latestComment ? (
                  <Comment
                    // key={index}
                    // order={index}
                    profilePic={latestComment?.photo}
                    username={latestComment?.fullname}
                    createdOn={latestComment?.created_on}
                    comment={latestComment?.comment}
                    // handleDelete={() => deleteComment(post?.latest_comment?.reflection_comment_id)}
                    deleteView={true}
                    // userId={post?.latest_comment?.user_id}
                    isView={isView}
                    guID={latestComment?.user_guid}
                    isPrivate={latestComment?.visibility}
                  />
                ) : (
                  <p className="lightColor text-sm">There is no comment yet.</p>
                )}{" "}
              </>
            )}
            {toggleComment === true && (
              <>
                {commentList.length > 0
                  ? commentList.map((comment, index) => (
                      <Comment
                        key={index}
                        order={index}
                        profilePic={comment.photo}
                        username={comment.fullname}
                        createdOn={comment.created_on}
                        comment={comment.comments}
                        handleDelete={() =>
                          deleteComment(comment.reflection_comment_id)
                        }
                        userId={comment.user_id}
                        isView={isView}
                        guID={comment.guid}
                        isPrivate={comment.visibility}
                      />
                    ))
                  : loadingComments === false && (
                      <p className="lightColor text-sm">
                        There is no comment yet.
                      </p>
                    )}
              </>
            )}
          </div>
          {loadingComments && (
            <div className="grid grid-cols-1 my-4">
              <div className="justify-center justify-self-center">
                <Loading active={loadingComments} />
              </div>
            </div>
          )}
          {toggleComment && hasMoreComments && (
            <div className="grid grid-cols-1 h-14">
              <div className="justify-center justify-self-center">
                <ButtonCommonTopNew
                  className="flex items-center justify-center border p-2 rounded-lg cursor-pointer text-sm"
                  onClick={loadMoreComments}
                >
                  Load more
                </ButtonCommonTopNew>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ReflectionCards;

// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import axios from "axios";

// import Swal from "sweetalert2";

// import { apiUrl, serverUrl } from "./Helpers/Config";

// import ButtonHashtag from "./Button/ButtonHashtag";

// import '../styles/feed.styles.scss';
// import moment from "moment";
// import AvatarGroup from "./LikeComment/AvatarGroup";
// import CommentInput from "./LikeComment/CommentInput";
// import { useHistory, useLocation } from "react-router-dom";
// import LikeComment from "./LikeComment/LikeComment";
// import { useDispatch } from "react-redux";
// import Comment from "./LikeComment/Comment";
// import { MdOutlineClose } from 'react-icons/md';
// import { useSelector } from "react-redux";
// import { deletePost, getChange } from "../redux/actions/userReflection";
// import { getProfilePic, htmlToText, trimString, convertDate, addAttribute, tokenAuthorize, removeIframe, Loading } from "./Helpers/Common";
// import { staticFiles } from "./Helpers/Static";
// import { ActiveIconColor, BgComment, BgWhite, ButtonCommonTop, Card, TextGray } from "../pages/Theme";
// import { theme } from "../pages/PageWrapper";
// import JournalHashtag from "./Button/JournalHashtag";
// import ButtonCommon from "./Button/ButtonCommon";

// const NO_IMAGE = staticFiles.noImage;

// const ReflectionCards = ({ item, shareToUser, handleLike, onPostDelete, isView, gridView }) => {
//     const history = useHistory()
//     const location = useLocation()

//     const userProfile = useSelector(state => state.auth.user);

//     const [comment, setComment] = useState('')
//     const [commentsCount, setCommentsCount] = useState("0");
//     const [latestComment, setLatestComment] = useState("0");
//     const postId = item.reflection_id

//     //shared
//     const isChange = useSelector(state => state.reflections.change);

//     const dispatch = useDispatch()
//     const userId = localStorage.getItem('user_id')
//     const [commentList, setCommentList] = useState([])
//     const [commentLatest, setCommentLatest] = useState([])
//     const [likesList, setLikesList] = useState([])

//     const [sortOrder, setsortOrder] = useState("desc");
//     const [numComments, setnumComments] = useState(0)
//     // let likesListDummy = [{photo: profilePhoto}, {photo: profilePhoto}, {photo: profilePhoto},
//     //                         {photo: profilePhoto}, {photo: profilePhoto}, {photo: profilePhoto},
//     //                     ]

//     const [toggleComment, setToggleComment] = useState(false)

//     const [currentIsLiked, setCurrentIsLiked] = useState()
//     const numLikes = parseInt(likesList.length)
//     // const numComments = commentList.length

//     const [sortOrderInitial, setsortOrderInitial] = useState("desc");
//     const [loadingComments, setLoadingComments] = useState(false);
//     const [offsetComments, setOffsetComments] = useState(0);
//     const [hasMoreComments, setHasMoreComments] = useState(false);

//     const handleCommentClick = () => {
//         if (gridView == false) {
//             setToggleComment(!toggleComment)
//             // if (!toggleComment === true) {
//             //     getComments(postId)
//             // }
//             let str = sortOrder
//             if (localStorage.getItem("sortOrder") != undefined) {
//                 str = localStorage.getItem("sortOrder")
//                 setsortOrder(str)
//             }
//             if (!toggleComment === false) {
//                 changeLike();
//                 setOffsetComments(0);
//                 setHasMoreComments(false);
//                 setsortOrderInitial(str);
//                 setCommentList([]);
//             }
//             if (!toggleComment === true) {
//                 setLoadingComments(true);
//                 getComments(str, offsetComments);
//             }
//             // if (!toggleComment === false) {
//             //     setsortOrder("desc")
//             // }
//             // getComments(str)
//         } else {
//             history.push(`/post/${postId}`, { src: location.pathname })
//         }
//     }

//     const loadMoreComments = () => {
//         setLoadingComments(true);
//         let count = offsetComments + 10;
//         setOffsetComments(offsetComments + 10);
//         getComments(sortOrder, count, true);
//     }

//     useEffect(() => {
//         let str = sortOrder
//         if (localStorage.getItem("sortOrder") != undefined) {
//             str = localStorage.getItem("sortOrder")
//         }
//         setsortOrder(str);
//         setsortOrderInitial(str);
//         // getComments(str)
//     }, [postId]);

//     useEffect(() => {
//         getLikes();
//         // getComments();
//         changeLike();
//     }, [])

//     const changeLike = () => {
//         return (axios.get(
//             apiUrl + 'reflection/' + postId
//         ).then(res => {
//             if (res.status === 200) {
//                 let like = res.data.post.like;
//                 setCurrentIsLiked(parseInt(like));
//                 setCommentsCount(res.data.post.comments_count);
//                 setLatestComment(res.data.post.latest_comment);
//             }
//         })
//         )
//     }

//     const getLikes = () => {
//         return axios.get(
//             apiUrl + 'likes/' + postId
//         ).then(resp => {
//             if (resp.status === 200) {
//                 let likesList = resp.data.results

//                 setLikesList(likesList)
//                 // dispatch(getShowcases());
//             }
//         })
//             .catch(err => {
//                 tokenAuthorize(err?.response?.status);
//                 console.log(err)
//             })

//     }

//     const likePost = (postId, isLiked) => {

//         return axios.post(
//             serverUrl.ReflectionPost + '/like',
//             { reflection_id: postId, like: isLiked }
//         ).then(resp => {
//             if (resp.status === 200) {
//                 getLikes(postId)
//                 changeLike();
//             }

//         }).catch((err) => {
//             tokenAuthorize(err?.response?.status);
//             console.log(err)
//         })
//     }

//     const getComments = (str, offset) => {
//         return axios.get(
//             apiUrl + 'comments/' + postId + "?sort_order=" + sortOrderInitial + "&limit=10&offset=" + offset
//         ).then(resp => {
//             if (resp.status === 200) {
//                 let data = [];
//                 data = resp.data.results;
//                 if (resp.data.results?.length > 9) {
//                     setHasMoreComments(true);
//                 } else {
//                     setHasMoreComments(false);
//                 }
//                 data = [
//                     ...data,
//                     ...commentList
//                 ]
//                 if (sortOrder == "asc") {
//                     const ascSortedData = data?.slice().sort((a, b) => new Date(a.created_on) - new Date(b.created_on));
//                     setCommentList(ascSortedData);
//                 }
//                 if (sortOrder == "desc") {
//                     const descSortedData = data?.slice().sort((a, b) => new Date(b.created_on) - new Date(a.created_on));
//                     setCommentList(descSortedData);
//                 }
//                 setLoadingComments(false);
//                 // let newCommentList = resp.data.results
//                 // setCommentList(newCommentList)
//                 // setnumComments(newCommentList.length);
//                 // if (newCommentList?.length > 0) {
//                 //     if (str == "desc") {
//                 //         setCommentLatest([newCommentList[0]])
//                 //     }
//                 //     if (str == "asc") {
//                 //         setCommentLatest([newCommentList[newCommentList?.length - 1]])
//                 //     }
//                 // }
//             } else {
//                 setLoadingComments(false);
//             }
//         }).catch(err => {
//             setLoadingComments(false);
//             tokenAuthorize(err?.response?.status);
//             console.log(err)
//         })

//     }

//     const deleteComment = (commentId) => {
//         Swal.fire({
//             heightAuto: false,
//             title: "Confirmation",
//             text: "Are you sure you want to delete this comment?",
//             icon: "warning",
//             showCancelButton: false,
//             showDenyButton: true,
//             confirmButtonText: "Confirm",
//             denyButtonText: "Cancel",
//             confirmButtonColor: "#3085d6",
//             denyButtonColor: "#c1c1c1",
//         }).then((result) => {
//             if (result.isConfirmed) {
//                 return axios.delete(
//                     serverUrl.Comment2 + '/' + commentId
//                 ).then(resp => {
//                     if (resp.status === 200) {
//                         let count = commentsCount - 1;
//                         setCommentsCount(count);
//                         let str = sortOrder
//                         if (localStorage.getItem("sortOrder") != undefined) {
//                             str = localStorage.getItem("sortOrder")
//                             setsortOrder(str)
//                         }
//                         const data = commentList.filter(item => item.reflection_comment_id !== commentId);
//                         setCommentList(data);
//                         // getComments(postId)
//                     }
//                 }).catch((err) => {
//                     tokenAuthorize(err?.response?.status);
//                     console.log(err)
//                 })
//             }
//         })
//     }

//     const addComment = (commentText, isPublic) => {

//         return axios.post(
//             serverUrl.ReflectionPost + '/comment',
//             { reflection_id: postId, comment: commentText, visibility: isPublic }
//         ).then(resp => {
//             if (resp.status === 200) {
//                 let str = sortOrder
//                 if (localStorage.getItem("sortOrder") != undefined) {
//                     str = localStorage.getItem("sortOrder");
//                     setsortOrder(str);
//                 }
//                 let count = commentsCount + 1;
//                 setCommentsCount(count);
//                 let object = [{
//                     "photo": userProfile?.photo,
//                     "fullname": userProfile?.fullname,
//                     "created_on": new Date(),
//                     "guid": userProfile?.guid,
//                     "reflection_comment_id": resp.data?.reflection_comment_id,
//                     "user_id": resp.data?.user_id,
//                     "comments": commentText,
//                     "visibility": isPublic
//                 }];
//                 if (toggleComment == false) {
//                     setCommentList([]);
//                     setOffsetComments(0);
//                     setToggleComment(true);
//                     setLoadingComments(true);
//                     getComments(str, offsetComments);
//                 } else {
//                     if (str == "desc") {
//                         if ((hasMoreComments == false || sortOrderInitial == "desc")) {
//                             setCommentList([
//                                 ...object,
//                                 ...commentList
//                             ]);
//                         }
//                     }
//                     if (str == "asc") {
//                         if (hasMoreComments == false || sortOrderInitial == "desc") {
//                             setCommentList([
//                                 ...commentList,
//                                 ...object,
//                             ]);
//                         }
//                     }
//                 }
//                 setComment('');
//             }

//         }).catch((err) => {
//             tokenAuthorize(err?.response?.status);
//             console.log(err)
//         })
//     }

//     const handleDeletePost = () => {
//         //---------------------------------------------------

//         if (shareToUser === true) {
//             Swal.fire({
//                 heightAuto: false,
//                 title: "Confirmation",
//                 text: "Are you sure to unshare this post?",
//                 icon: "warning",
//                 showCancelButton: false,
//                 showDenyButton: true,
//                 confirmButtonText: "Confirm",
//                 denyButtonText: "Cancel",
//                 confirmButtonColor: "#3085d6",
//                 denyButtonColor: "#c1c1c1",
//             }).then((result) => {
//                 if (result.isConfirmed) {
//                     return axios.delete(
//                         serverUrl.UnshareUser + '/' + item.shared_user_id
//                     ).then(res => {
//                         if (res.status === 200) {
//                             dispatch(getChange(!isChange));
//                         }
//                     }).catch((err) => {
//                         console.log(err);
//                         tokenAuthorize(err?.response?.status);
//                     })
//                 }
//             })
//         }
//         else if (shareToUser === false) {
//             Swal.fire({
//                 heightAuto: false,
//                 title: "Confirmation",
//                 text: "Are you sure to unshare this post?",
//                 icon: "warning",
//                 showCancelButton: false,
//                 showDenyButton: true,
//                 confirmButtonText: "Confirm",
//                 denyButtonText: "Cancel",
//                 confirmButtonColor: "#3085d6",
//                 denyButtonColor: "#c1c1c1",
//             }).then((result) => {
//                 if (result.isConfirmed) {
//                     return axios.delete(
//                         serverUrl.UnshareGroup + '/' + item.shared_group_id
//                     ).then(res => {
//                         if (res.status === 200) {
//                             dispatch(getChange(!isChange));
//                         }
//                     }).catch((err) => {
//                         console.log(err);
//                         tokenAuthorize(err?.response?.status);
//                     })
//                 }
//             })
//         }

//         //-------------------------------------------------
//         else {
//             Swal.fire({
//                 heightAuto: false,
//                 title: "Confirmation",
//                 text: "Are you sure to unshare this post?",
//                 icon: "warning",
//                 showCancelButton: false,
//                 showDenyButton: true,
//                 confirmButtonText: "Confirm",
//                 denyButtonText: "Cancel",
//                 confirmButtonColor: "#3085d6",
//                 denyButtonColor: "#c1c1c1",
//             }).then((result) => {
//                 if (result.isConfirmed) {
//                     return axios.delete(
//                         serverUrl.Community + '/' + item.group_id + "/posts/" + postId
//                     ).then(res => {
//                         if (res.status === 200) {
//                             dispatch(deletePost(item.group_id, postId))
//                         }
//                     }).catch((err) => {
//                         console.log(err);
//                         tokenAuthorize(err?.response?.status);
//                     })
//                 }
//             })
//         }
//     }

//     const handleSort = (str) => {
//         setsortOrder(str)
//         localStorage.setItem("sortOrder", str)
//         if (str == "asc") {
//             const ascSortedData = commentList?.slice().sort((a, b) => new Date(a.created_on) - new Date(b.created_on));
//             setCommentList(ascSortedData);
//         }
//         if (str == "desc") {
//             const descSortedData = commentList?.slice().sort((a, b) => new Date(b.created_on) - new Date(a.created_on));
//             setCommentList(descSortedData);
//         }
//         // getComments(str)
//     }

//     return (
//         <div className={`${gridView == true ? 'feed-full' : 'feed'} ${'cardBackgroundColor rounded-lg overflow-hidden mb-4 relative cursor-pointer'}`} onClick={() => history.push(`/post/${postId}`, { src: location.pathname })}>
//             <div className='p-4 md:p-8 flex justify-between'>
//                 <div className='flex h-20 md:h-16 items-center pr-4'>
//                     <Link to={"/profile/" + item.guid} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
//                         <img src={getProfilePic(item.photo)} alt="pics" className='rounded-full w-12 h-12 object-cover mx-3' />
//                     </Link>
//                     <div className="text-sm md:text-base">
//                         <div className='font-bold'>{trimString(item.reflection_title, 50)}</div>
//                         <div className="flex">by &nbsp;
//                             <Link className="nav-navigate" to={"/profile/" + item.guid} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
//                                 <ActiveIconColor className="hover:underline">{trimString(item.fullname, 55)}</ActiveIconColor>
//                             </Link>
//                         </div>
//                         {
//                             shareToUser !== true &&
//                             <div className='flex flex-col' onClick={(e) => e.stopPropagation()}>
//                                 {item.group_name ?
//                                     <div className="flex">in&nbsp;
//                                         {location.pathname === `/community/groups/${item.group_id}` ?
//                                             trimString(item.group_name, 55)
//                                             :
//                                             <a
//                                                 className="cursor-pointer nav-navigate"
//                                                 onClick={() => history.push(`/community/groups/${item.group_id}`, { src: location.pathname })}>
//                                                 <ActiveIconColor className="hover:underline">{trimString(item.group_name, 55)}</ActiveIconColor>
//                                             </a>
//                                         }
//                                     </div> : <></>}

//                                 {/* {
//                                     item.group_name &&
//                                     <div>&nbsp;{item.group_name}</div>
//                                     // item.groups.map((group, idx) => {
//                                     //     if(item.groups.length === idx+1){
//                                     //         return(
//                                     //             <div>&nbsp;{group.value}</div>
//                                     //         )
//                                     //     } else {
//                                     //         return(
//                                     //             <div>&nbsp;{group.value}{','} </div>
//                                     //         )
//                                     //     }
//                                         // <div className='ml-1'>{' '}{group.value}{','}</div>
//                                     // })
//                                 } */}
//                             </div>
//                         }
//                         <div>
//                             {moment.utc(item.reflection_created_on).local().startOf('seconds').fromNow()} ({convertDate(item.reflection_created_on)})
//                         </div>

//                     </div>
//                 </div>
//                 <ActiveIconColor className='flex items-center text-gray-400 absolute top-4 md:top-8 right-4 md:right-8 text-sm md:text-base"' onClick={(e) => e.stopPropagation()}>
//                     {
//                         item.updateable &&
//                         <MdOutlineClose
//                             className="cursor-pointer opacity-100 hover:opacity-80 w-6 h-6 ml-4"
//                             onClick={handleDeletePost}
//                         />
//                     }
//                     {
//                         (shareToUser === true || shareToUser === false) &&
//                         <MdOutlineClose
//                             className="cursor-pointer opacity-100 hover:opacity-80 w-6 h-6 ml-4"
//                             onClick={handleDeletePost}
//                         />
//                     }
//                 </ActiveIconColor>
//             </div>
//             {/* {
//             item.reflection_image && */}
//             <img
//                 className='w-full h-80 object-cover'
//                 src={item.reflection_image ? item.reflection_image?.replaceAll(" ", "%20") : NO_IMAGE}
//                 onError={(e) => { e.target.src = NO_IMAGE }}

//             />

//             {/* } */}
//             <div className='px-4 pt-4 md:px-8 md:pt-8 mx-3 h-52 overflow-hidden'>
//                 <div className='mb-6 text-viewer break-words'>
//                     <div className="multiline-ellipsis6" dangerouslySetInnerHTML={{ __html: item.reflection_content }} />
//                     {/* { trimString(htmlToText(item.reflection_content), 200) } */}
//                 </div>
//             </div>

//             <span className="px-4 md:px-8 mx-3 h-4">
//                 {item.reflection_content &&
//                     <strong className="hover:opacity-80 cursor-pointer">
//                         Read more
//                     </strong>}
//             </span>

//             <div className="px-4 pb-4 md:px-8 md:pb-8 mx-3 h-52">
//                 <div className={`${gridView == true ? "h-12 overflow-hidden mb-2" : ""} ${'flex pb-4 flex-wrap pt-4'}`}>
//                     {
//                         item.hashtag &&
//                         item.hashtag.map((hashtag, idx) => (
//                             <JournalHashtag key={idx} text={hashtag} color="blue" style={"mr-2 my-1"} />
//                         ))
//                     }
//                 </div>
//                 <div className='flex mb-6 justify-between md:justify-start' onClick={e => e.stopPropagation()}>
//                     {likesList.length > 0 &&
//                         <div class={"mr-5"}>
//                             <AvatarGroup likesList={likesList} />
//                         </div>}
//                     <LikeComment
//                         currentIsLiked={currentIsLiked}
//                         numLikes={numLikes}
//                         numComments={commentsCount}
//                         handleComment={handleCommentClick}
//                         likesList={likesList}
//                         handleLike={e => {
//                             e.stopPropagation();
//                             likePost(postId, currentIsLiked === 1 ? 0 : 1);
//                         }}
//                     />

//                 </div>

//                 <CommentInput
//                     comment={comment}
//                     setComment={setComment}
//                     commentPost={addComment}
//                     profilePhoto={staticFiles.noProfilePic}
//                 />
//             </div>
//             {gridView == false &&
//                 <BgComment
//                     // className={toggleComment === true ? "block pt-1 rounded-b-xl py-5" : "hidden"}
//                     className={"block pt-1 rounded-b-xl py-5"}
//                     // style={{'backgroundColor': '#F9F9F9'}}
//                     onClick={(e) => e.stopPropagation()}
//                 >
//                     {commentList.length > 1 && <>
//                         {toggleComment == true && <>
//                             <div className="flex flex-row items-center absolute right-0" style={{ marginTop: '10px', marginRight: '10px' }}>
//                                 {sortOrder == "asc" &&
//                                     <ButtonCommonTop className="w-6 h-6 cursor-pointer" onClick={() => handleSort("desc")} title="Sort by Latest">
//                                         <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16" style={{ paddingLeft: '4px', paddingTop: '3px' }} onClick={() => handleSort("desc")}>
//                                             <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z" />
//                                         </svg>
//                                     </ButtonCommonTop>}
//                                 {sortOrder == "desc" &&
//                                     <ButtonCommonTop className="w-6 h-6 cursor-pointer ml-3" onClick={() => handleSort("asc")} title="Sort by Oldest">
//                                         <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16" style={{ paddingLeft: '4px', paddingTop: '3px' }} onClick={() => handleSort("asc")}>
//                                             <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z" />
//                                         </svg>
//                                     </ButtonCommonTop>}
//                             </div></>}</>}
//                     <div className="mx-10" style={{ marginTop: (toggleComment == true && commentList?.length > 1) ? '60px' : "" }}>
//                         {toggleComment === false && <>
//                             {latestComment ?
//                                 <Comment
//                                     // key={index}
//                                     // order={index}
//                                     profilePic={latestComment?.photo}
//                                     username={latestComment?.fullname}
//                                     createdOn={latestComment?.created_on}
//                                     comment={latestComment?.comment}
//                                     // handleDelete={() => deleteComment(post?.latest_comment?.reflection_comment_id)}
//                                     deleteView={true}
//                                     // userId={post?.latest_comment?.user_id}
//                                     isView={isView}
//                                     guID={latestComment?.user_guid}
//                                     isPrivate={latestComment?.visibility}
//                                 />
//                                 :
//                                 <p className="pt-3">There is no comment yet.</p>
//                             } </>}
//                         {toggleComment === true && <>
//                             {commentList.length > 0
//                                 ? commentList.map((comment, index) => (
//                                     <Comment
//                                         key={index}
//                                         order={index}
//                                         profilePic={comment.photo}
//                                         username={comment.fullname}
//                                         createdOn={comment.created_on}
//                                         comment={comment.comments}
//                                         handleDelete={() => deleteComment(comment.reflection_comment_id)}
//                                         userId={comment.user_id}
//                                         isView={isView}
//                                         guID={comment.guid}
//                                         isPrivate={comment.visibility}
//                                     />
//                                 ))
//                                 : loadingComments === false && <p className="pt-3">There is no comment yet.</p>
//                             }</>}
//                     </div>
//                     {loadingComments &&
//                         <div className="grid grid-cols-1 h-10 pt-3">
//                             <div className="justify-center justify-self-center">
//                                 <Loading active={loadingComments} />
//                             </div>
//                         </div>
//                     }
//                     {toggleComment && hasMoreComments &&
//                         <div className="grid grid-cols-1 h-14 pt-3">
//                             <div className="justify-center justify-self-center">
//                                 <ButtonCommon
//                                     className="px-10 py-3" title="Load more"
//                                     onClick={loadMoreComments}
//                                 />
//                             </div>
//                         </div>}
//                 </BgComment>}
//         </div>
//     )
// }

// export default ReflectionCards;
